import React from 'react';
import { AdviceOutcome, DecisionModuleType, DecisionOutcome } from '../../../../constants/DecisionModuleOutcome';
import OutcomeGauge from '../OutcomeGauge/OutcomeGauge';
import OutcomeFactors from '../OutcomeFactors/OutcomeFactors';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './style/decisionmoduleoutcome.scss';

const DecisionModuleOutcome = ({
       type,
       outcome,
       translatedOutcome,
       outcomeHeader,
       outcomeText,
       intellectualCapability,
       competencies,
       languageId,
       i18n,
       classes,
       selfForwardingToNextPhase,
       forwardToNextPhase,
       participantId
   }) => {
    const getGaugeColorClass = () => {
        switch (outcome) {
            case AdviceOutcome.LOW:
            case DecisionOutcome.NEGATIVE:
                return style.gaugeRed;
            case AdviceOutcome.MEDIUM:
                return style.gaugeOrange;
            case AdviceOutcome.HIGH:
            case DecisionOutcome.POSITIVE:
                return style.gaugeGreen;
            default:
                return '';
        }
    }

    const getAmountOfColoredArcs = () => {
        switch (outcome) {
            case AdviceOutcome.LOW:
            case DecisionOutcome.NEGATIVE:
                return 1;
            case AdviceOutcome.MEDIUM:
            case DecisionOutcome.POSITIVE:
                return 2;
            case AdviceOutcome.HIGH:
                return 3;
            default:
                return 0;
        }
    }

    return (
        <section className={`${style.outcomeContent} ${classes.outcomeContent}`}>
            <section>
                <OutcomeGauge
                    amountOfArcs={type === DecisionModuleType.ADVICE ? 3 : 2}
                    amountOfColoredArcs={getAmountOfColoredArcs()}
                    outcomeText={translatedOutcome}
                    classes={{
                        root: `${style.outcomeGauge} ${classes.outcomeGauge}`,
                        outcomeText: classes.outcomeText,
                        color: getGaugeColorClass()
                    }}
                />
                <div className={`${style.outcomeDescription} ${classes.outcomeDescription}`}>
                    <section className={style.outcomeTexts}>
                        <h4>{outcomeHeader}</h4>
                        <div dangerouslySetInnerHTML={{ __html: outcomeText }} />
                    </section>
                    <OutcomeFactors
                        competencies={competencies}
                        intellectualCapability={intellectualCapability}
                        languageId={languageId}
                        i18n={i18n}
                    />
                    { selfForwardingToNextPhase && participantId && forwardToNextPhase
                        ? <button
                            className={`button_type_a modal ${style.buttonToNextPhase}`}
                            data-cy="decision-module-outcome-to-next-phase-button"
                            onClick={event => {
                                event.stopPropagation();
                                forwardToNextPhase(participantId);
                            }}
                        >{i18n.report_section_decision_module_outcome_to_next_phase}<FontAwesomeIcon icon={ 'arrow-right' }/>
                        </button>
                        : null }
                </div>
            </section>
        </section>
    )
};

export default DecisionModuleOutcome;

DecisionModuleOutcome.propTypes = {
    type: PropTypes.oneOf([DecisionModuleType.ADVICE, DecisionModuleType.DECISION]).isRequired,
    outcome: PropTypes.oneOf([DecisionOutcome.POSITIVE, DecisionOutcome.NEGATIVE, AdviceOutcome.HIGH, AdviceOutcome.MEDIUM, AdviceOutcome.LOW]).isRequired,
    translatedOutcome: PropTypes.string.isRequired,
    outcomeHeader: PropTypes.string,
    outcomeText: PropTypes.string,
    intellectualCapability: PropTypes.object,
    competencies: PropTypes.array,
    classes: PropTypes.object,
    languageId: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired,
    selfForwardingToNextPhase: PropTypes.bool,
    forwardToNextPhase: PropTypes.function,
    participantId: PropTypes.number
};

DecisionModuleOutcome.defaultProps = {
    classes: {
        outcomeContent: '',
        outcomeGauge: '',
        outcomeDescription: ''
    },
    selfForwardingToNextPhase: false
};
